export default __webpack_public_path__ + "static/media/JOSA CLASS-6 EXAM PATTERN 2026-27.8285a49f.pdf";